import { lazy } from 'react';

// project imports
import Loadable from 'ui-components/loadhandlers/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

const HostDirectory = Loadable(lazy(() => import('views/host-directory')));
const HostStorefront = Loadable(lazy(() => import('views/host-storefront')));
const PublicPackage = Loadable(lazy(() => import('views/host-storefront/package')));

// ==============================|| HOST STOREFRONT ROUTING ||============================== //

/*
 * The customer side of the travel host area: the host directory
 * (host-directory-tech-design §9.1), a public storefront per approved host and
 * a page per published package (host-storefront-tech-design §9.1).
 *
 * MinimalLayout, not MainLayout: these pages are for guests, most of them
 * signed out, arriving from a shared link. The pages draw their own slim
 * header (StorefrontShell); MinimalLayout renders `<Outlet />` only.
 *
 * `/hosts` is plural on purpose. `isHostAreaPath` in utils/host-area-access.js
 * matches `/host` and `/host/*` only, so neither the host-area guards nor
 * MainLayout's PortalProtector can ever claim these URLs.
 *
 * Whether a storefront shows at all is the server's call, per request: with
 * HOST_STOREFRONT_MODE off every slug answers 404 and these routes render the
 * not-found page, so registering them ships nothing a guest can see.
 */
const StorefrontRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      // The directory. A static segment, so it never collides with a slug;
      // its filters are query parameters, never `/hosts/<word>`.
      path: 'hosts',
      element: <HostDirectory />
    },
    {
      path: 'hosts/:hostSlug',
      element: <HostStorefront />
    },
    {
      // `<title-slug>-<id>`; only the trailing id is authoritative.
      path: 'hosts/:hostSlug/packages/:packageSlugId',
      element: <PublicPackage />
    }
  ]
};

export default StorefrontRoutes;
